import './index.scss';
import React from 'react';
import Loading from '../loading/loading';

interface IIfProps extends React.HTMLAttributes<HTMLDivElement> {
    loading: boolean;
    className?: string;
    skeletonClassName?: string;
    style?: React.CSSProperties;
    children: JSX.Element | null | JSX.Element[];
    skeleton?: JSX.Element | null | JSX.Element[];
}

export const VisibleLoading = (props: IIfProps) => {
    const { className = '', skeletonClassName = '', style = {}, loading, skeleton, children } = props;
    const renderLoading = () => {
        if (!loading) {
            return null;
        }
        return <div className={`visible-loading_skeleton ${skeletonClassName}`}>{skeleton || <Loading />}</div>;
    };

    return (
        <div className={`visible-loading ${className}`}>
            {renderLoading()}
            <div
                style={{
                    visibility: loading ? 'hidden' : 'visible',
                    ...(loading ? style : {}),
                }}
            >
                {children}
            </div>
        </div>
    );
};
